// eslint-disable-next-line max-len
export default function leaseIntegration({
  customer,
  country,
  entity,
  state,
  address3,
  title,
  contactBackup,
  proratedRent,
  parkingNames,
  warehouseNames,
  officeNames,
  naics,
  monthlyOpex,
  totalLicensePlusOpex,
  proratedTotalLicensePlusOpex,
  leasePrice, moveIn, deposit, details, managerName, managerTitle, utils, warehouseSize, officeSize, parking,
}) {
  const date = new Date();
  const currentDate = date.toLocaleDateString('en-US');
  return {
    company: customer.company,
    dateOfLicense: currentDate,
    entityType: entity,
    moveIn: moveIn.toLocaleDateString('en-US'),
    organizationState: state || '-',
    taxId: customer.taxId,
    licenseFee: leasePrice,
    proratedLicenseFee: proratedRent,
    primaryContactName: customer.name,
    securityDeposit: deposit,
    primaryContactTitle: title,
    customerAddress1: customer.address,
    naics,
    customerAddress2: customer.address2,
    customerAddress3: address3,
    term: details.term,
    customerCountry: country,
    customerPhone: customer.phone,
    customerEmail: customer.email,
    hoursOfAccess: details.hoursOfAccess,
    maxOnSiteEmployees: details.onSiteEmployees,
    industry: details.industry,
    backupContactName: contactBackup.name,
    useOfSpace: details.subIndustry,
    backupAddress1: contactBackup.address1,
    backupAddress2: contactBackup.address2,
    backupPhone: contactBackup.phone,
    backupEmail: contactBackup.email,
    selfServiceCheckbox: warehouseSize > 0,
    totalWarehouseSQFT: warehouseSize,
    warehouseUnitNumbers: warehouseNames,
    privateOfficeCheckbox: officeSize > 0,
    totalOfficeSQFT: officeSize,
    officeUnitNumbers: officeNames,
    parkingCheckbox: parking > 0,
    // casta7619c70184b11ee89b0b9c2aee9a418,
    parkingSpots: parking,
    parkingUnitNumbers: parkingNames,
    // castc3b1fe60184b11ee89b0b9c2aee9a418
    primaryEmail2: customer.email,
    // customerInitials: ,
    rsImprovements: utils.rsImprovements,
    memberImprovements: utils.memberObligationImprovements,
    memberRightImprovements: utils.memberRightImprovements,
    urpfo: utils.utils,
    lienHolders: utils.lienHolders,
    // rsManagerSignature: ,
    // customerSignature: ,
    rsManagerName: managerName,
    rsManagerTitle: managerTitle,
    monthlyOpex,
    totallicenseplusopex: totalLicensePlusOpex,
    proratedtotallicenseplusopex: proratedTotalLicensePlusOpex,
  };
}



// WEBPACK FOOTER //
// ./src/utils/leaseIntegration.js